module.exports = __webpack_public_path__ + "static/img/shop-close.f5ee04d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report/shop-close.png
// module id = dDzu
// module chunks = 2